<template>
  <div id="pageRoot">
    <p id="text01" class="textBase pageElement">
      Entonces le tocó el turno a Serafín. Empezó la búsquda, pero era tan
      difícil reunir mil perlas en un solo día que se sentó sobre una piedra y
      se largó a llorar. Mientras lloraba, apareció la reina de las hormigas
      acompañada por cinco mil obreras. Antes del anochecer, las hormigas que él
      había salvado le acercaron las mil perlas. Así fue como Serafín cumplió
      con la primera prueba.<br><br>
      La segunda prueba consistía en sacar del fondo del
      mar la llave de la habitación de las princesas. El hermano menor se acercó
      a la orilla. ¿Como iba a poder, él solo, encontrar una llave en el inmenso
      mar? No bien pensó eso, se largo a llorar. Enseguida, los patos a los que
      el habia salvado se acercaron nadando. Los patos se sumergieron en el mar,
      encontraron la llave y se la pusieron en la mano, chorreando agua todavía.<br><br>
      La tercera prueba era la mas difícil. Había que entrar a la habitación
      donde dormían las tres hijas del rey y despertar a la menor con un beso en
      la mejilla. Si el principe besaba a la princesa equivocada, quedaría
      convertido en piedra.<br><br>
      ¿Como podía distinguirlas? Habían nacido el mismo día
      y eran tan idénticas como tres gotas de agua. Solo se diferenciaban —le
      explicó el hombrecito— en que, antes de quedarse dormidas por el
      encantamiento, la hermana mayor había tomado un terrón de azucar, la
      segunda, una cucharada de dulce de leche y Catalina, la menor, una
      cucharada de miel.
    </p>
  </div>
</template>
<style scoped>
#text01 {
  position: absolute;
  width: 947px;
  left: 41px;
  top: 25px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 11.mp4", "cas/Video 12.mp4", "cas/Video 13b.mp4",],
    }
  }
}
</script>